module.exports = __webpack_public_path__ + "img/comp-lundzo.e4a66254.svg";